// src/domains/user/userCustomers.store.ts

import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { IUserCustomer } from './user.types';
import { customStorage } from '@/shared/lib/storage';
import { registerClear } from '@/shared/lib/storesRegistry';

interface IUserCustomersStore {
  customers: IUserCustomer[];
  selectedCustomerUuid: string | null;
  selectedCustomer: IUserCustomer | null;
  setCustomers: (customers: IUserCustomer[]) => void;
  selectCustomer: (customer: IUserCustomer) => void;
  clearCustomers: () => void;
}

export const useUserCustomersStore = create<IUserCustomersStore>()(
  devtools(
    persist(
      (set, get) => ({
        customers: [],
        selectedCustomerUuid: null,
        selectedCustomer: null,
        setCustomers: (customers) => {
          const preferredUuid = get().selectedCustomerUuid;

          const preferredFresh = preferredUuid
            ? customers.find((c) => c.uuid === preferredUuid)
            : null;

          const nextSelected = preferredFresh ?? customers[0] ?? null;

          set({
            customers,
            selectedCustomer: nextSelected,
            selectedCustomerUuid: nextSelected?.uuid ?? null,
          });
        },

        selectCustomer: (customer) =>
          set({
            selectedCustomer: customer,
            selectedCustomerUuid: customer.uuid,
          }),
        clearCustomers: () =>
          set({
            customers: [],
            selectedCustomer: null,
            selectedCustomerUuid: null,
          }),
      }),
      {
        name: 'user-customers-storage',
        storage: customStorage,
        partialize: (state) => ({
          selectedCustomerUuid: state.selectedCustomerUuid,
        }),
      },
    ),
    { name: 'UserCustomersStore' },
  ),
);

registerClear(useUserCustomersStore.getState().clearCustomers);
